//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import statistics from '@/utils/statistics.js';
export default {
  props: {
    bubbleApi: {
      type: String,
      require: false,
      default: '/v1/ys2020/shop',
    },
    payProduct: {
      type: Boolean,
      require: false,
      default: true,
    },
  },
  data() {
    return {
      isBubbleShow: false,
      fadeStatus: '',
      len: '',
      data_bubble: [
        {
          time: '',
          name: '',
        },
      ],
      nowIndex: 0,
      data_head: '',
    };
  },
  watch: {
    nowIndex: {
      handler(nVal, oVal) {
        if (nVal) {
          this.tips();
        }
      },
      immediate: true,
    },
  },
  created() {
    this.fetch_bubble();
  },
  methods: {
    fetch_bubble() {
      let apiParam = {
        qd: this.$Glb.getAttribute().qd,
        posId: this.$Glb.getAttribute().posId,
        is_new_user: statistics.call(this),
      };
      this.$api.post(this.bubbleApi, apiParam, (res) => {
        if (res.code == 1) {
          this.data_bubble = res.data.user;
          this.len = this.data_bubble.length;
          if (this.len) {
            this.isBubbleShow = true;
          }
          var randomNum = Math.floor(Math.random() * 15 + 1);
          this.data_head = require('./_img/glb_ad_head' + randomNum + '.png');
          // console.log(this.data_bubble);
          this.tips();
        }
      });
    },
    tips() {
      var randomTime = Math.floor(Math.random() * 2 + 1);
      setTimeout(() => {
        if (this.nowIndex < this.len) {
          if (this.nowIndex < this.len - 1) {
            var randomNum = Math.floor(Math.random() * 15 + 1);
            this.data_head = require('./_img/glb_ad_head' + randomNum + '.png');
            this.fadeStatus = 'fadeIn';
            this.nowIndex++;
          } else {
            this.isBubbleShow = false;
          }
        }
      }, randomTime * 3000);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/the-bubble.vue